export const rating = [
    {
      id:1,
      ratinglabel: "1🌟",
      value: 1
    },
    {
      id:2,
        ratinglabel: "2🌟",
      value: 2
    },
    {
      id:3,
      ratinglabel: "3🌟",
      value: 3
    },
    {
      id:4,
      ratinglabel: "4🌟",
      value: 4
    },
    {
       id:4, 
      ratinglabel: "5🌟",
      value: 5
    }
  ];